import { ShieldCheckIcon } from '@heroicons/react/24/outline';

export default function AlertsPage() {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <div className="flex items-center">
            <ShieldCheckIcon className="h-8 w-8 text-purple-600 mr-3" />
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Alertes de Sécurité</h1>
              <p className="text-gray-600 mt-1">Notifications et alertes importantes</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="text-center py-12">
            <ShieldCheckIcon className="h-16 w-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Module d'Alertes de Sécurité
            </h3>
            <p className="text-gray-600 mb-4">
              Cette fonctionnalité sera implémentée prochainement
            </p>
            <div className="text-sm text-gray-500">
              <p>Fonctionnalités à venir :</p>
              <ul className="mt-2 space-y-1">
                <li>• Alertes en temps réel</li>
                <li>• Notifications de sécurité</li>
                <li>• Historique des alertes</li>
                <li>• Actions requises</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
